import React from 'react';
import { NewTabLink } from '../components/new-tab-link';
import ChevronousText from '@mapbox/mr-ui/chevronous-text';
import Heading from '@mapbox/mr-ui/heading';
import { PageWrapper } from '../components/page-wrapper';
import PageShell from '../components/page-shell';

export default class ContactSales extends React.Component {
  getSidebarSections() {
    return [
      {
        body: (
          <ul>
            <li className="mb12">
              <NewTabLink
                href="https://www.mapbox.com/atlas"
                className="link"
                track="Clicked to view Atlas marketing page"
              >
                <ChevronousText text="Learn more about Atlas" />
              </NewTabLink>
            </li>
            <li className="mb12">
              <NewTabLink
                href="https://www.mapbox.com/contact/"
                className="link"
                track="Clicked contact us from Atlas page"
              >
                <ChevronousText text="Contact us" />
              </NewTabLink>
            </li>
          </ul>
        )
      }
    ];
  }

  render() {
    return (
      <PageShell>
        <PageWrapper
          sectionName="Contact Us"
          sidebarSections={this.getSidebarSections()}
        >
          <h4 className="my24">
            <Heading variant="minor">
              Whoops! Looks like you don't have access to Mapbox Atlas.
            </Heading>
          </h4>
          <div className="prose my24 col col--12-mm">
            <p>
              Contact us to find out more information about running Mapbox
              securely from your own infrastructure.
            </p>
          </div>
          <div className="my24 col col--12-mm align-center">
            <a
              href="https://www.mapbox.com/contact/sales"
              ref="ContactSales"
              className="btn px24 round-full txt-s transition color-white"
            >
              Contact Sales
            </a>
          </div>
        </PageWrapper>
      </PageShell>
    );
  }
}

export { ContactSales };
